import React from "react";
import "./Deve-service.scss";
import { CiMobile3 } from "react-icons/ci";
import { AiOutlineCloudDownload, AiOutlineSolution } from "react-icons/ai";
import { RiPagesLine, RiServerLine } from "react-icons/ri";
import { BsFillBuildingFill, BsSpeedometer2 } from "react-icons/bs";
import { TbPageBreak } from "react-icons/tb";

const services = [
  {
    id: 1,
    icon: <CiMobile3 />,
    title: "Mobile App Development",
    desc: "Craft high-performing Android and iOS applications with seamless UX and responsive design.",
  },
  {
    id: 2,
    icon: <RiPagesLine />,
    title: "Web Development",
    desc: "Modern, scalable, and SEO-friendly websites that connect you with the digital world.",
  },
  {
    id: 3,
    icon: <BsFillBuildingFill />,
    title: "Infrastructure Management",
    desc: "Ensure secure, stable, and scalable IT infrastructure for all your business operations.",
  },
  {
    id: 4,
    icon: <TbPageBreak />,
    title: "Fastest Coding",
    desc: "Clean, optimized, and efficient code built for performance and maintainability.",
  },
  {
    id: 5,
    icon: <BsSpeedometer2 />,
    title: "Virtualization Solutions",
    desc: "Cut costs and improve efficiency with modern virtualization technologies.",
  },
  {
    id: 6,
    icon: <AiOutlineCloudDownload />,
    title: "Cloud Computing",
    desc: "Empower your business with secure, scalable, and reliable cloud-based solutions.",
  },
  {
    id: 7,
    icon: <RiServerLine />,
    title: "Big Data Solutions",
    desc: "Transform data into insights through analytics and smart data engineering.",
  },
  {
    id: 8,
    icon: <AiOutlineSolution />,
    title: "IoT Solutions",
    desc: "Connect, monitor, and automate devices with powerful IoT-driven systems.",
  },
];

const DeveService = () => {
  return (
    <section className="service-section">
      <div className="service-header">
        <h2>Our Development Services</h2>
        <p>
          At V-Ex Tech Solution, we provide cutting-edge digital services that
          help transform your ideas into scalable and powerful solutions.
        </p>
      </div>

      <div className="service-grid">
        {services.map((service) => (
          <div key={service.id} className="service-card">
            <div className="icon-wrapper">
              <span className="icon">{service.icon}</span>
            </div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DeveService;
